import { Component, Renderer2 } from '@angular/core';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';
import { LexbeThemeService } from '@services/lexbe-theme.service';

@Component({
    selector: 'lex-doc-viewer-settings-dialog',
    templateUrl: './doc-viewer-settings-dialog.component.html',
    styleUrls: ['./doc-viewer-settings-dialog.component.scss'],
    standalone: false
})
export class DocViewerSettingsDialogComponent extends BaseComponent {
	public mode: 'viewer' | 'review' = 'viewer';
	public isDarkTheme: boolean = false;
	public viewerLabel: string = 'Try new PDF Viewer';

	private viewerType: 'default' | 'integrated';

	constructor(
		public docViewerStore: DocViewerStore,
		private renderer: Renderer2,
		private themeService: LexbeThemeService
	) {
		super();
		this.docViewerStore.simpleState$.pipe(
			takeUntil(this.destroy$)
		).subscribe((current) => {
			this.mode = current.mode;
		});

		this.isDarkTheme = this.themeService.isDarkMode();
		this.themeService.isDarkMode$.subscribe((value) => {
			this.setTheme(value);
		});

		const viewer = localStorage.getItem("pdf-viewer-version");
		this.viewerType = viewer as ('default' | 'integrated') ?? 'default';
		this.viewerLabel = this.getViewerLabel(this.viewerType);
	}

	public toggleTheme($event) {
		this.themeService.setLocalStorage($event.checked);
		this.setTheme($event.checked);
	}

	public setTheme(isDarkTheme: boolean) {
		this.isDarkTheme = isDarkTheme;

		if (this.isDarkTheme) {
			this.renderer.addClass(document.body, 'dark-theme');
		}
		else {
			this.renderer.removeClass(document.body, 'dark-theme');
		}
	}

	public togglePdfViewer(): void {
		if (this.viewerType === 'default')
			this.viewerType = 'integrated';
		else
			this.viewerType = 'default';
		localStorage.setItem('pdf-viewer-version', this.viewerType)
		window.location.reload();
	}

	private getViewerLabel(type: 'default' | 'integrated'): string {
		return type === 'integrated' ? 'Use default PDF Viewer' : 'Try new PDF Viewer';
	}
}
